import React, { useState } from 'react';
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/high-res.css';

interface CountryProps {
  name: string;
  dialCode: string;
  countryCode: string;
}

export interface InternationalPhoneInputProps {
  countryCode?: string;
  onlyCountries: string[];
  phoneNumber: string;
  error?: boolean;
  onChange?: (phone: string, country: CountryProps) => void;
  onEnterKeyPress?: (e: React.KeyboardEvent<HTMLInputElement>) => void;
}

const inputStyle: React.CSSProperties = {
  color: '#ffffff',
  backgroundColor: '#a8b0b8',
  fontSize: '14px',
  border: '1px solid #ffffff',
  textAlign: 'left',
  borderRadius: '4px',
  width: '100%',
};

const inputStyleWithError: React.CSSProperties = {
  ...inputStyle,
  borderColor: '#ff0000',
};

const buttonStyle = {
  color: '#071c35',
  backgroundColor: '#f5f5f5',
  border: '1px solid #ffffff',
};

const buttonStyleWithError = {
  ...buttonStyle,
  borderBottomColor: '#ff0000',
  borderLeftColor: '#ff0000',
  borderTopColor: '#ff0000',
};

export const InternationalPhoneInput: React.FC<InternationalPhoneInputProps> = ({
  countryCode = 'us',
  onlyCountries,
  phoneNumber,
  error = false,
  onChange,
  onEnterKeyPress,
}) => {
  // There is a bug in react-phone-input-2.
  // Clearing the field with empty string breaks the functionality of this component.
  // Hence keeping a track of the input dialcode and setting it as the value when the input is cleared.
  const [dialCodeInput, updateDialCodeInput] = useState('');
  const inputValue = phoneNumber || `+${dialCodeInput}`;

  const lowerCasedCountryCode = countryCode.toLowerCase();
  const lowerCasedOnlyCountries = onlyCountries.map(onlyCountry =>
    onlyCountry.toLowerCase(),
  );

  const defaultCountry = lowerCasedOnlyCountries.includes(lowerCasedCountryCode)
    ? lowerCasedCountryCode
    : lowerCasedOnlyCountries[0];

  return (
    <PhoneInput
      disableDropdown={onlyCountries.length === 1}
      countryCodeEditable={false}
      country={defaultCountry}
      onlyCountries={lowerCasedOnlyCountries}
      value={inputValue}
      inputStyle={error ? inputStyleWithError : inputStyle}
      buttonStyle={error ? buttonStyleWithError : buttonStyle}
      onChange={(phone, country) => {
        updateDialCodeInput((country as CountryProps).dialCode);
        onChange && onChange(`+${phone}`, country  as CountryProps);
      }}
      onEnterKeyPress={onEnterKeyPress}
    />
  );
};

export default InternationalPhoneInput;